import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ExternalView from './ExternalView';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

export default function ExternalViewPage({
  jobId,
  applicationId,
  externalViewId,
  loginHash
}: {
  jobId: number;
  applicationId: number;
  externalViewId: string;
  loginHash: string;
}) {
  return (
    <QueryClientProvider client={queryClient}>
      <ExternalView {...{ jobId, applicationId, externalViewId, loginHash }} />
    </QueryClientProvider>
  );
}
